<template>
  <main v-if="!model.isTplHidden">
    <section class="fk-contents">
      <h2 class="title-lv2 mb10">{{$t('Payment.Method')}}</h2>
      <h3 class="title-lv3 mb20">{{$t('Payment.Select')}}</h3>

      <span v-if="!model.DPayEnabled">
      <div class="pay-list">
        <ul>
          <li class="pay-selected">
            <a id="btnPayPay" href="#" class="paypaymodal-open" @click.prevent="displayModal">
              <img src="@/assets/images/logo1_paypay.png" />
              {{$t('Payment.PayPay')}}
            </a>
            <div class="paypaymodal-container">
              <div class="paypaymodal-body">
                <div class="paypaymodal-close" @click="closeModal">×</div>
                <div class="paypaymodal-content">
                  <div class="inner">
                    <p class="txt-center txt-red txt-bold"><i class="fa-solid fa-triangle-exclamation"></i>{{$t('PayPayDialog.Precaution1')}}<br class="sp-only">{{$t('PayPayDialog.Precaution2')}}</p>
                    <p>{{$t('PayPayDialog.Precaution3')}}<br class="pc-only"><span class="txt-red txt-underline">{{$t('PayPayDialog.Precaution4')}}</span></p>
                  </div>
                  <div class="btn btn-yellow"><a href="#" class="txt-center txt-bold" @click.prevent="callLink('paypay')">{{$t('PayPayDialog.UnderstandPrecaution')}}</a></div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <a id="btnAuPay" href="#" @click.prevent="callLink('aupay')">
              <img src="@/assets/images/logo2_aupay.png" />
              {{$t('Payment.AuPay')}}
            </a>
          </li>
          <li>
            <a id="btnRakutenPay" href="#" @click.prevent="callLink('rakutenv2')">
              <img src="@/assets/images/logo3_rpay.png" />
              {{$t('Payment.RakutenPay')}}
            </a>
          </li>
          <li>
            <a id="btnDPay" href="#" @click.prevent="callLink('docomo')">
              <img src="@/assets/images/logo4_d.png" />
              {{$t('Payment.DPay')}}
            </a>
          </li>
          <li>
            <a id="btnCredit" href="#" @click.prevent="goCreditCard">
              <img src="@/assets/images/icon_creditcard.png" />
              {{$t('Payment.CreditCard')}}
            </a>
          </li>
          <li  :class="model.CanUseMFCard || 'btn-negative btn-quit'" style="transition:unset!important" :style="model.CanUseMFCard || 'pointer-events:none'">
            <a id="btnMF" href="#" @click.prevent="goMFCard">
              <img src="@/assets/images/icon_mfcard.png" />
              {{$t('Payment.MyFirstCard')}}
            </a>
          </li>
        </ul>
      </div>
      <div class="card_list">
        <img src="@/assets/images/credit_visa.png" alt="VISA" />
        <img src="@/assets/images/credit_jcb.png" alt="JCB" />
        <img src="@/assets/images/credit_mastercard.png" alt="mastercard" />
      </div>
      </span>
      <span v-else>
        <p class="mod-form-btn"><a href="#" class="btn-base btn-sub" @click.prevent="callDPay">{{$t('Payment.UseDPay')}}</a></p>
      </span>

      <div class="mod-has-label">
        <span class="label">{{$t('Cart.ReceiveMethod')}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{getOrderDetail.receiveMethod}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Cart.OrderDetail')}}</span>
        <div class="mod-normal-box">
          <div class="order-detail-wrap">
            <!-- *** 商品 *** -->
            <div class="order-detail-item" v-for="(item, index) in getOrderDetail.items" :key="index">
              <h3 class="item-coupon-use" v-if="item.isUseCoupon">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="item.name"></span></h3>
              <div class="quantity">{{text.Quantity}}{{item.quantity}}</div>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(item.price)}}</strong><small>{{item.taxType}}</small></p>
            </div>
            <!-- *** 商品 *** -->
            <!-- *** 会計割引クーポン *** -->
            <div class="order-detail-item" v-if="getOrderDetail.accountingCoupon.isUse">
              <h3 class="item-coupon-use">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="getOrderDetail.accountingCoupon.title"></span></h3>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(getOrderDetail.accountingCoupon.discountPrice)}}</strong><small>{{getOrderDetail.accountingCoupon.taxType}}</small></p>
            </div>
            <!-- *** 会計割引クーポン *** -->
            <p class="total-price"><small>{{$t('General.Total')}}</small><strong>¥{{displayThousandsSeparator(getOrderDetail.totalPrice)}}</strong><small>{{getOrderDetail.taxType}}</small></p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {get, set, forEach} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOPaymentMethod',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      orderList: [],
      totalPrice: null,
      receiveMethod: null,
      text: {
        CouponExcluded: null,
        NotApplying: null,
        UseCoupon: null,
        Quantity: null
      },
      model: {
        CanUseMFCard: false,
        DPayEnabled: false,
        isTplHidden: true
      }
    }
  },
  computed: {
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getOrderDetail () {
      return this.$store.getters.orderDetail
    }
  },
  setup () {
    let styleBtn = 'auto'
    return styleBtn
  },
  methods: {
    goCreditCard: function (event) {
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }
      localStorage.setItem('linkPayMethod', '')
      this.changePaySelected(document.getElementById('btnCredit'))
      this.$router.push({ name: 'InputCreditCard' })
    },
    goMFCard: function (event) {
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }
      localStorage.setItem('linkPayMethod', '')
      this.changePaySelected(document.getElementById('btnMF'))
      if (!this.model.CanUseMFCard) {
        return false
      }
      this.$router.push({ name: 'InputMFCard' })
    },

    // d払い処理
    callDPay: function (event) {
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }
      localStorage.setItem('linkPayMethod', '')
      const _that = this
      // 決済情報連携インタフェース結果取得処理
      window.receivePaymentResult = (res) => {
        const itemNameArray = []
        forEach(get(_that.getOrderDetail, 'items', []), (o) => {
          itemNameArray.push({item_name: o.name})
        })
        const param = {}
        set(param, 'order_id', _that.getOrderDetail.orderId)
        set(param, 'display_item_info', itemNameArray)
        set(param, 'dcm_payment_result', JSON.parse(res))
        // d払い決済結果通知APIコール
        this.callApi('DcmExecute',
          param
        ).then((res) => {
          if (get(res, 'data.result', false)) {
            // 注文番号をStoreに格納
            let order = _that.getOrderDetail
            order.ticketNumber = res.data.value.ticket_number
            _that.$store.dispatch('setOrderDetail', order)

            // カート情報をクリアする
            _that.clearCart(true)

            _that.$router.push({ name: 'OrderProcessing' })
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
      }

      // トークン取得APIコール
      this.callApi('DcmGetToken',
        {
          order_id: _that.getOrderDetail.orderId,
          settlement_amount: _that.getOrderDetail.totalPrice
        }
      ).then((res) => { // 決済情報連携インタフェース
        const mobillsToken = get(res.data, 'value.dcm_token_result.mobillsToken', null)
        if (res.data.result && mobillsToken !== null) {
          const dcmParam = JSON.stringify({
            token: mobillsToken,
            amount: '' + _that.getOrderDetail.totalPrice,
            mode: '01',
            param: _that.getOrderDetail.orderId
          })
          if (_that.$store.getters.isDPayAndroid) {
            /* eslint no-undef: 0 */
            android.payment(dcmParam)
          } else if (_that.$store.getters.isDPayiOS) {
            window.webkit.messageHandlers.payment.postMessage(dcmParam)
          }
        } else {
          _that.errorFromApi(res.data.errorCode, res.data.error)
        }
      })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
          _that.model.isTplHidden = false
        })
    },

    // 表示用受取店舗情報を生成
    genReceiveStore: function () {
      this.storeData = {
        name: this.getSelectStore.store_name,
        address: this.getSelectStore.address,
        lastOrder: this.getSelectStore.lastorder_time,
        tel: this.getSelectStore.tel,
        lat: this.getSelectStore.latitude,
        lng: this.getSelectStore.longitude,
        imageUrl: this.getSelectStore.image_url
      }
    },
    // 端末情報取得
    getTerminalInfo: function () {
      const _that = this
      this.callApi('MFCardGetTerminalInfo',
        {
          'store_cd': this.getSelectStore.store_cd
        }
      )
        .then((res) => {
          if (res.data.result) {
            _that.model.CanUseMFCard = res.data.value.can_use_mfcard
          } else {
            _that.model.CanUseMFCard = false
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.model.CanUseMFCard = false
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.setDisabledButton(false)
          _that.model.isTplHidden = false
        })
    },
    // d払い情報取得
    getDPayInfo: function () {
      this.model.DPayEnabled = this.$store.getters.isDPayEnabled
    },
    initView: function () {
      this.text.CouponExcluded = this.$i18n.t('Cart.CouponExcluded')
      this.text.NotApplying = this.$i18n.t('Cart.NotApplying')
      this.text.UseCoupon = this.$i18n.t('Cart.UseCoupon')
      this.text.Quantity = this.$i18n.t('General.Quantity')
      // d払い情報取得
      this.getDPayInfo()
    },
    init: function () {
      // 注文明細を生成する
      this.genOrderDetail()
      // 受取方法
      this.receiveMethod = this.getTextReceiveMethod()
      // 端末情報取得
      this.getTerminalInfo()
    },
    // paypay支払い時の注意ダイアログ表示
    displayModal: function () {
      var container = document.querySelector('.paypaymodal-container')

      // 開くボタンをクリックしたらモーダルを表示する
      container.classList.add('active')

      // モーダルの外側をクリックしたらモーダルを閉じる
      window.onclick = (e) => {
        if (e.target === container) {
          container.classList.remove('active')
        }
      }
    },
    // 注意ダイアログの閉じるボタン押下時の処理
    closeModal: function () {
      document.querySelector('.paypaymodal-container').classList.remove('active')
    },
    //
    /**
     * 選択した支払い方法のボタンを枠で囲む
     * @param {*} btn
     */
    changePaySelected: function (btn) {
      if (document.querySelector('.pay-selected')) {
        document.querySelector('.pay-selected').classList.remove('pay-selected')
      }
      btn.parentNode.classList.add('pay-selected')
    },
    /**
     * リンク型決済のうちで押下したボタン要素取得
     *
     * @param {string} method
     */
    getBtnElement: function (method) {
      let btn = document.getElementById('btnPayPay')
      switch (method) {
        case 'aupay':
          btn = document.getElementById('btnAuPay')
          break
        case 'docomo':
          btn = document.getElementById('btnDPay')
          break
        case 'paypay':
          btn = document.getElementById('btnPayPay')
          break
        case 'rakutenv2':
          btn = document.getElementById('btnRakutenPay')
          break
        default:
          break
      }
      return btn
    },
    /**
     * 購入要求(リンク型)用のタグを生成
     * @param {*} name タグエレメント名
     * @param {*} value 設定内容
     */
    createSbpsElement: function (name, value) {
      const element = document.createElement('input')
      element.type = 'hidden'
      element.name = name
      element.value = value
      return element
    },
    // セッションストレージ、ローカルストレージの情報をDBに退避
    saveStorageInfo: async function () {
      const _that = this
      const storageInfo = {
        lang: sessionStorage.getItem('lang'),
        vuex: sessionStorage.getItem('vuex')
      }
      if (sessionStorage.getItem('login') !== null) {
        storageInfo['login'] = sessionStorage.getItem('login')
      }
      if (sessionStorage.getItem('email') !== null) {
        storageInfo['email'] = sessionStorage.getItem('email')
      }

      try {
        const res = await this.callApi('SaveStorage',
          {
            'storage_info': JSON.stringify({encodedData: btoa(encodeURI(JSON.stringify(storageInfo)))})
          })
        if (get(res, 'data.result', false)) {
          return res.data.value.storageKey
        } else {
          _that.errorFromApi(res.data.errorCode, res.data.error)
        }
      } catch (error) {
        this.errorFromAxios(error)
      }
    },
    /**
     * SBPSの購入要求(リンク型)ページへ必要情報を渡して遷移
     * @param {*} method 決済方法
     */
    callLink: async function (method) {
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }

      // paypayだったらモーダルを消す
      if (method === 'paypay') {
        document.querySelector('.paypaymodal-container').classList.remove('active')
      }
      const btn = this.getBtnElement(method)
      this.changePaySelected(btn)

      // 楽天ペイ支払い金額チェック
      if (method === 'rakutenv2' && this.getOrderDetail.totalPrice < 100) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_201'))
        return
      }

      // PayPayの時はストレージ（ローカル、セッション両方）情報をjson形式で保存する
      let storageKey = null
      if (method === 'paypay') {
        storageKey = await this.saveStorageInfo()
        if (storageKey === null || storageKey === undefined) {
          return
        }
      }

      localStorage.setItem('linkPayMethod', method)
      const req = {
        order_id: null,
        display_item_info: []
      }
      req.order_id = this.getOrderDetail.orderId
      // バックエンドに渡す商品名のリストを生成する
      for (var i = 0; i < this.getOrderDetail.items.length; i++) {
        req.display_item_info.push({ 'item_name': this.getOrderDetail.items[i].name })
      }

      const that = this
      this.callApi('PaymentRequestPreprocessing',
        req
      ).then(async (res) => {
        if (get(res, 'data.result', false)) {
          const form = document.createElement('form')
          form.action = this.getSbpsSetting().payRequestURL
          form.method = 'POST'
          form.acceptCharset = 'shift_jis'
          var param = {}
          // 支払い方法
          param.pay_method = method
          // マーチャントID
          param.merchant_id = this.getSbpsSetting().merchantId
          // サービスID
          param.service_id = this.getSbpsSetting().serviceId
          // 顧客ID
          param.cust_code = res.data.value.sbpsCustCode
          // SBPS 顧客 ID
          param.sps_cust_no = ''
          // SBPS 支払方法管理番号
          param.sps_payment_no = ''
          // 購入ID
          param.order_id = res.data.value.sbpsOrderId
          // 商品ID
          param.item_id = this.getSbpsSetting().itemId
          // 外部決済機関商品 ID
          param.pay_item_id = ''
          // 商品名称
          param.item_name = this.getSbpsSetting().itemName
          // 税額
          param.tax = ''
          // 金額(税込)
          param.amount = this.getOrderDetail.totalPrice
          // 購入タイプ
          param.pay_type = 0
          // 自動課金タイプ
          param.auto_charge_type = ''
          // サービスタイプ
          param.service_type = 0
          // 決済区分
          param.div_settele = ''
          // 最終課金月
          param.last_charge_month = ''
          // キャンペーンタイプ
          param.camp_type = ''
          // トラッキング ID
          param.tracking_id = ''
          // 顧客利用端末タイプ
          param.terminal_type = 0
          // 決済完了時URL
          if (method === 'paypay') {
            param.success_url = res.data.value.successUrl + '?bskey=' + storageKey
          } else {
            param.success_url = res.data.value.successUrl
          }
          // 決済キャンセル時URL
          param.cancel_url = res.data.value.cancelUrl
          // エラー時URL
          param.error_url = res.data.value.errorUrl
          // 決済通知用CGI
          param.pagecon_url = res.data.value.pageconUrl
          // 自由欄1
          param.free1 = res.data.value.storeCode
          // 自由欄2
          param.free2 = ''
          // 自由欄3
          param.free3 = ''
          // フリー項目
          param.free_csv = ''
          // リクエスト日時
          param.request_date = res.data.value.serverTime
          // リクエスト許容時間
          param.limit_second = 600
          // チェックサム
          this.callApi('GenSbpsHashKey',
            param
          ).then((res) => {
            param.sps_hashcode = res.data.value.hashcode

            // BASE64変換
            this.callApi('GenBase64',
              param
            ).then(async (res) => {
              // エレメント生成
              for (let key in param) {
                form.appendChild(this.createSbpsElement(key, param[key]))
              }
              await document.body.appendChild(form)
              // 現在のsessionStorageを退避
              if (method !== 'paypay') {
                localStorage.setItem('lang_link', sessionStorage.getItem('lang'))
                localStorage.setItem('vuex_link', JSON.stringify(sessionStorage.getItem('vuex')))
                if (sessionStorage.getItem('login') !== null) {
                  localStorage.setItem('login_link', sessionStorage.getItem('login'))
                }
                if (sessionStorage.getItem('email') !== null) {
                  localStorage.setItem('email_link', sessionStorage.getItem('email'))
                }
              }
              form.submit()
            })
          })
        } else {
          this.errorFromApi(res.data.errorCode, res.data.error)
        }
      })
        .catch((error) => {
          that.errorFromAxios(error)
        })
    }
  },
  watch: {
    'getOrderDetail' (detail) {
      this.orderList = detail.items
      this.totalPrice = detail.totalPrice
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style>
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
</style>



// WEBPACK FOOTER //
// src/components/PaymentMethod.vue